import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/livepro/logo.png'
import _imports_1 from '@/assets/img/event/benefits-background.png'
import _imports_2 from '@/assets/img/event/ueno/notes-img.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-50059746")

_pushScopeId("data-v-50059746")
const _hoisted_1 = { class: "livepro-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lp-header" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "onlylive-img",
    src: _imports_0
  })
], -1)
const _hoisted_3 = { class: "livepro-main" }
const _hoisted_4 = { class: "livepro-main-content-bottom" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ライブプロ × onlylive")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { id: "benefits" }, [
  /*#__PURE__*/_createVNode("div", { class: "benefits-section" }, [
    /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
      /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_1 }),
        /*#__PURE__*/_createVNode("p", null, "1位")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefit-common" }, [
        /*#__PURE__*/_createVNode("h2", null, "Amazonギフト券　3000円分プレゼント（1名）"),
        /*#__PURE__*/_createVNode("p", null, "ランキング1位のタレント様1名に上記の特典をプレゼント")
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
      /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_1 }),
        /*#__PURE__*/_createVNode("p", null, "特別賞")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefit-common" }, [
        /*#__PURE__*/_createVNode("h2", null, "Amazonギフト券　1000円分プレゼント（2位~10位から5名）"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode("ランキング2位~10位のタレント様の中から最も開催した5名に上記の特典をプレゼント"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("※月8回以上開催した方限定")
        ])
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "benefits-top" }, [
      /*#__PURE__*/_createVNode("div", { class: "rank-top" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_1 }),
        /*#__PURE__*/_createVNode("p", null, "ランダム賞")
      ]),
      /*#__PURE__*/_createVNode("div", { class: "benefit-common" }, [
        /*#__PURE__*/_createVNode("h2", null, "Amazonギフト券　1000円分プレゼント（10位以下から1名）"),
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode("ランキング10位以下のタレント様の中からランダムで1名に上記の特典をプレゼント"),
          /*#__PURE__*/_createVNode("br"),
          /*#__PURE__*/_createTextVNode("※月8回以上開催した方限定")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_8 = { class: "event-ranking-body-section" }
const _hoisted_9 = { class: "ranking-section" }
const _hoisted_10 = { class: "notes-section" }
const _hoisted_11 = { class: "notes-section-container" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "notes-top-title" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_2 })
], -1)
const _hoisted_13 = { class: "notes-contents" }
const _hoisted_14 = /*#__PURE__*/_createVNode("li", null, "・最終ランキングの発表は、翌月の上旬に発表します。", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("li", null, "・ランキングの更新は1時間おきに行われます", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "livepro-footer" }, [
  /*#__PURE__*/_createVNode("p", null, "© 2022 ILEO,inc.")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Ranking = _resolveComponent("Ranking")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("h1", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createTextVNode(_toDisplayString(_ctx.startDate.getMonth() + 1) + "月ランキング特典", 1)
      ]),
      _hoisted_7,
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Ranking, {
            event: _ctx.state.event,
            rankingUsers: _ctx.state.ranking
          }, null, 8, ["event", "rankingUsers"])
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode("ul", _hoisted_13, [
            _createVNode("li", null, "・" + _toDisplayString(_ctx.startDate.getFullYear()) + "年" + _toDisplayString(_ctx.startDate.getMonth() + 1) + "月1日0時00分以降通話開始分から、" + _toDisplayString(_ctx.endDate.getFullYear()) + "年" + _toDisplayString(_ctx.endDate.getMonth() + 1) + "月" + _toDisplayString(_ctx.endDate.getDate()) + "日23時59分59秒通話開始分までがランキングに加算されます。", 1),
            _createVNode("li", null, "・" + _toDisplayString(_ctx.endDate.getFullYear()) + "年" + _toDisplayString(_ctx.endDate.getMonth() + 1) + "月" + _toDisplayString(_ctx.endDate.getDate()) + "日23時59分59秒に通話が開始された場合、終了するまでがランキングに加算されます。（延長分も加算されます）", 1),
            _hoisted_14,
            _hoisted_15
          ])
        ]),
        _hoisted_16
      ])
    ])
  ]))
})